<template>
  <Toast />
  <ul class="list-none p-0 m-0 flex align-items-center font-medium">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">INVENTARIO</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3 active">HISTORIAL DE TRASPASOS</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div class="flex align-items-center flex-column lg:justify-content-center lg:flex-row">
      <span style="border-bottom: 1px solid #005f91; font-size: 1.5rem">
        <strong>HISTORIAL DE TRASPASOS</strong>
      </span>
    </div>
    <div class="col-12 p-fondo">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-1">
          <span><strong>CÓDIGO: </strong></span>
          <InputText v-model="cod_traspaso" placeholder="Cod. Mov" :class="'text-right'" @keyup.enter="BuscarFiltro" />
        </div>
        <div class="field col-12 md:col-3">
          <span><strong>FECHA TRASPASO DESDE: </strong></span>
          <Calendar v-model="fecha_traspaso_desde" dateFormat="dd/mm/yy" :showIcon="true" />
        </div>
        <div class="field col-12 md:col-3">
          <span><strong>FECHA TRASPASO HASTA: </strong></span>
          <Calendar v-model="fecha_traspaso_hasta" dateFormat="dd/mm/yy" :showIcon="true" />
        </div>
        <div class="field col-12 md:col-2">
          <span><strong>AGRUPAR POR: </strong></span>
          <Dropdown
            v-model="agrupar_por"
            :options="opciones_agrupacion"
            optionLabel="label"
            optionValue="value"
            class="w-full"
            @change="cambiarAgrupacion"
          />
        </div>
        <div class="field col-12 md:col-3">
          <span><strong>ACCIONES: </strong></span>
          <Button
            label="APLICAR FILTROS"
            icon="pi pi-search"
            class="p-button-info"
            v-tooltip.top="'Buscar'"
            :loading="enviando"
            :disabled="enviando"
            @click="BuscarFiltro"
          />
        </div>
      </div>
    </div>
    <div class="mt-4">
      <DataTable
        ref="dt_traspasos"
        dataKey="id"
        :value="gruposTabla"
        responsiveLayout="scroll"
        :loading="enviando"
        class="p-datatable-sm traspasos-table"
        :filters="buscar"
        :globalFilterFields="[
          'titulo',
          'subtitulo',
          'sucursal_principal',
          'sucursal_destino',
          'preparado_por',
          'recido_por',
          'observaciones'
        ]"
        responsive="true"
        stripedRows
        showGridlines
        :rows="50"
        :paginator="true"
        v-model:expandedRows="expandedRows"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[50, 100, 500, 1000, 5000, 10000]"
        currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} grupos de traspasos"
      >
        <template #header>
          <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-end gap-2">
            <div class="table-title">
              <strong>{{ tituloTabla }}</strong>
              <span>{{ gruposTabla.length }} grupos / {{ traspasos.length }} movimientos</span>
            </div>
            <div class="flex flex-column md:flex-row gap-2">
              <span class="block p-input-icon-left">
                <i class="pi pi-search" />
                <InputText v-model="buscar['global'].value" placeholder="Buscar grupo..." />
              </span>
              <Button
                icon="pi pi-plus"
                class="p-button-info p-button-outlined"
                :disabled="gruposTabla.length === 0"
                @click="expandirTodo"
              />
              <Button
                icon="pi pi-minus"
                class="p-button-secondary p-button-outlined"
                :disabled="expandedRows.length === 0"
                @click="contraerTodo"
              />
              <Button
                :label="'DESCARGAR PDF'"
                icon="pi pi-file-pdf"
                class="p-button-danger"
                v-tooltip.top="'Imprimir Reporte PDF'"
                :loading="generandoPDF"
                :disabled="generandoPDF"
                @click="generarPDF"
              />
            </div>
          </div>
        </template>
        <template #loading>
          <div class="flex align-items-center justify-content-center">
            <ProgressSpinner />
          </div>
        </template>
        <template #empty>
          <span class="p-invalid"> Debe aplicar filtros para ver resultados en la tabla!</span>
        </template>
        <Column expander style="width: 3rem" />
        <Column
          field="titulo"
          :header="agrupar_por === 'producto' ? 'PRODUCTO' : 'CÓDIGO DE TRASPASO'"
          :sortable="true"
        >
          <template #body="{ data }">
            <div class="grupo-main">
              <span class="grupo-title">{{ data.titulo }}</span>
              <span class="grupo-subtitle">{{ data.subtitulo }}</span>
            </div>
          </template>
        </Column>
        <Column field="total_cantidad" header="TOTAL" class="text-center" :sortable="true">
          <template #body="{ data }">
            <span class="total-badge">{{ sinDecimal(data.total_cantidad) }}</span>
          </template>
        </Column>
        <Column field="sucursal_principal" header="ORIGEN"></Column>
        <Column field="sucursal_destino" header="DESTINO"></Column>
        <Column field="preparado_por" header="PREPARADO POR"></Column>
        <Column field="recido_por" header="RECIBIDO POR"></Column>
        <template #expansion="{ data }">
          <div class="detalle-traspaso">
            <div class="detalle-title">
              <strong>Detalle</strong>
              <span>{{ data.items.length }} movimiento{{ data.items.length !== 1 ? 's' : '' }}</span>
            </div>
            <DataTable :value="data.items" class="p-datatable-sm" responsiveLayout="scroll" stripedRows showGridlines>
              <Column v-if="agrupar_por === 'producto'" field="codigo" header="CÓD"></Column>
              <Column v-if="agrupar_por === 'producto'" field="fecha_movimiento" header="FECHA"></Column>
              <Column v-if="agrupar_por === 'codigo'" field="nombre_producto" header="PRODUCTO"></Column>
              <Column field="color_nombre" header="COLOR">
                <template #body="{ data: detalle }">
                  <div class="flex align-items-center gap-2">
                    <span v-if="detalle.color_hex" :style="circuloColor(detalle.color_hex)" />
                    {{ detalle.color_nombre ?? '-' }}
                  </div>
                </template>
              </Column>
              <Column field="talla_nombre" header="TALLA">
                <template #body="{ data: detalle }">
                  {{ detalle.talla_nombre ?? '-' }}
                </template>
              </Column>
              <Column field="cantidad" header="CANTIDAD" class="text-center">
                <template #body="{ data: detalle }">
                  <strong>{{ sinDecimal(detalle.cantidad) }}</strong>
                </template>
              </Column>
              <Column v-if="agrupar_por === 'producto'" field="sucursal_principal" header="ORIGEN"></Column>
              <Column v-if="agrupar_por === 'producto'" field="sucursal_destino" header="DESTINO"></Column>
              <Column field="observaciones" header="OBSERVACIÓN">
                <template #body="{ data: detalle }">
                  {{ detalle.observaciones ?? '-' }}
                </template>
              </Column>
            </DataTable>
          </div>
        </template>
        <Column field="observaciones" header="OBSERVACIÓN">
          <template #body="{ data }">
            {{ data.observaciones ?? '-' }}
          </template>
        </Column>
        <Column header="ACCIONES" class="text-center" style="width: 90px">
          <template #body="{ data }">
            <Button
              icon="pi pi-file-pdf"
              class="p-button-danger p-button-sm p-button-outlined"
              v-tooltip.top="tooltipPDFGrupo(data)"
              :loading="pdfGrupoCargando === data.id"
              :disabled="generandoPDF || pdfGrupoCargando !== null"
              @click="generarPDFGrupo(data)"
            />
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>
<script>
import { FilterMatchMode } from 'primevue/api'
import { useAuth } from '@/stores'
import MovimientoInventarioService from '@/service/MovimientoInventarioService'

export default {
  data() {
    return {
      enviando: false,
      fecha_traspaso_desde: null,
      fecha_traspaso_hasta: null,
      cod_traspaso: null,
      agrupar_por: 'codigo',
      opciones_agrupacion: [
        { label: 'Código de traspaso', value: 'codigo' },
        { label: 'Producto', value: 'producto' }
      ],
      generandoPDF: false,
      buscar: {
        global: {
          value: '',
          matchMode: FilterMatchMode.CONTAINS
        }
      },
      traspasos: [],
      traspasos_agrupados: [],
      expandedRows: [],
      pdfGrupoCargando: null
    }
  },
  auth: null,
  movimientoInventarioService: null,
  created() {
    this.auth = useAuth()
    this.movimientoInventarioService = new MovimientoInventarioService()
  },
  computed: {
    tituloTabla() {
      return this.agrupar_por === 'producto' ? 'Traspasos agrupados por producto' : 'Traspasos agrupados por código'
    },
    gruposTabla() {
      return this.traspasos_agrupados.map((grupo, index) => {
        const items = grupo.items ?? []
        const primero = items[0] ?? {}
        return {
          ...grupo,
          id: `${this.agrupar_por}-${grupo.clave ?? index}`,
          items,
          titulo: grupo.titulo ?? this.tituloGrupoDesdeItem(primero),
          subtitulo: this.subtituloGrupoDesdeDatos(grupo, primero),
          observaciones: this.observacionesGrupo(items),
          sucursal_principal: grupo.sucursal_principal ?? primero.sucursal_principal,
          sucursal_destino: grupo.sucursal_destino ?? primero.sucursal_destino,
          preparado_por: grupo.preparado_por ?? primero.preparado_por,
          recido_por: grupo.recido_por ?? primero.recido_por
        }
      })
    }
  },
  methods: {
    sinDecimal(numero) {
      return parseInt(numero)
    },
    circuloColor(hex) {
      if (!hex) return ''
      return `width: 15px; height: 15px; border-radius: 50%; background-color: ${hex}; display: inline-block; border: 1px solid #ccc;`
    },
    imprimirTraspaso(id) {
      this.movimientoInventarioService
        .imprimirTraspaso(id)
        .then(() => {})
        .catch(() => {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudo generar el PDF del traspaso',
            life: 3000
          })
        })
    },
    generarPDF() {
      if (this.traspasos.length > 0) {
        this.generandoPDF = true
        let datos = {
          cod_traspaso: this.cod_traspaso,
          fecha_traspaso_desde: this.fecha_traspaso_desde,
          fecha_traspaso_hasta: this.fecha_traspaso_hasta,
          agrupar_por: this.agrupar_por
        }
        this.movimientoInventarioService
          .imprimirPDF(datos)
          .then(() => {
            this.$toast.add({
              severity: 'success',
              summary: 'Éxito',
              detail: 'Se generó el PDF correctamente',
              life: 3000
            })
          })
          .catch(() => {
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: 'No se pudo generar el PDF',
              life: 3000
            })
          })
          .finally(() => {
            this.generandoPDF = false
          })
      } else {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'No hay datos para generar el reporte',
          life: 3000
        })
      }
    },
    generarPDFGrupo(grupo) {
      if (!grupo?.items?.length) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'No hay datos para generar este PDF',
          life: 3000
        })
        return
      }

      this.pdfGrupoCargando = grupo.id
      const datos = {
        fecha_traspaso_desde: this.fecha_traspaso_desde,
        fecha_traspaso_hasta: this.fecha_traspaso_hasta,
        agrupar_por: this.agrupar_por
      }

      if (this.agrupar_por === 'producto') {
        datos.producto_id = grupo.clave
      } else {
        datos.cod_traspaso = grupo.codigo ?? grupo.clave
      }

      this.movimientoInventarioService
        .imprimirPDF(datos)
        .then(() => {
          this.$toast.add({
            severity: 'success',
            summary: 'Éxito',
            detail: 'Se generó el PDF del grupo correctamente',
            life: 3000
          })
        })
        .catch(() => {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudo generar el PDF del grupo',
            life: 3000
          })
        })
        .finally(() => {
          this.pdfGrupoCargando = null
        })
    },
    tooltipPDFGrupo(grupo) {
      return this.agrupar_por === 'producto' ? `Descargar PDF de ${grupo.titulo}` : `Descargar PDF del ${grupo.titulo}`
    },
    BuscarFiltro() {
      this.traspasos = []
      this.traspasos_agrupados = []
      this.expandedRows = []
      this.enviando = true
      this.cargarTraspasos()
    },
    cambiarAgrupacion() {
      this.expandedRows = []
      if (this.traspasos.length > 0) {
        this.enviando = true
        this.cargarTraspasos()
      }
    },
    cargarTraspasos() {
      let datos = {
        cod_traspaso: this.cod_traspaso,
        fecha_traspaso_desde: this.fecha_traspaso_desde,
        fecha_traspaso_hasta: this.fecha_traspaso_hasta,
        agrupar_por: this.agrupar_por
      }
      this.movimientoInventarioService
        .filtrarTraspasos(datos)
        .then((response) => {
          this.traspasos = response.traspasos
          this.traspasos_agrupados = response.traspasos_agrupados ?? []
        })
        .catch(() => {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudo cargar el historial de traspasos',
            life: 3000
          })
        })
        .finally(() => {
          this.enviando = false
        })
    },
    expandirTodo() {
      this.expandedRows = this.gruposTabla
    },
    contraerTodo() {
      this.expandedRows = []
    },
    tituloGrupoDesdeItem(data) {
      if (this.agrupar_por === 'producto') {
        const codigo = data.codigo_interno ? `${data.codigo_interno} - ` : ''
        return `${codigo}${data.nombre_producto ?? 'SIN PRODUCTO'}`
      }
      return `TRASPASO ${data.codigo ?? '-'}`
    },
    subtituloGrupoDesdeDatos(grupo, primero) {
      if (this.agrupar_por === 'producto') {
        return `${grupo.total_lineas ?? 0} movimiento${grupo.total_lineas !== 1 ? 's' : ''} del producto`
      }
      return `${primero.sucursal_principal ?? grupo.sucursal_principal ?? '-'} a ${
        primero.sucursal_destino ?? grupo.sucursal_destino ?? '-'
      } / ${primero.preparado_por ?? grupo.preparado_por ?? '-'}`
    },
    observacionesGrupo(items) {
      const observaciones = items.map((item) => item.observaciones).filter(Boolean)
      return observaciones.length ? observaciones[0] : '-'
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/demo/badges.scss';

.p-invalid {
  color: red;
}

.p-fondo {
  background-color: #7bffae;
  border-radius: 5px;
  border: 1px solid #002236;
  padding: 5px;
}

.table-title {
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: #1e293b;
}

.table-title strong {
  font-size: 1rem;
}

.table-title span {
  color: #64748b;
  font-size: 0.8rem;
}

.grupo-main {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.grupo-title {
  color: #0f172a;
  font-weight: 800;
}

.grupo-subtitle {
  color: #64748b;
  font-size: 0.78rem;
}

.total-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 58px;
  padding: 4px 8px;
  border-radius: 6px;
  background: #dcfce7;
  color: #166534;
  font-weight: 800;
}

.detalle-traspaso {
  background: #f8fafc;
  border: 1px solid #dbeafe;
  border-radius: 8px;
  padding: 10px;
}

.detalle-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  color: #1e293b;
}

.detalle-title span {
  color: #64748b;
  font-size: 0.8rem;
}

:deep(.traspasos-table .p-row-toggler) {
  width: 2rem;
  height: 2rem;
  border-radius: 7px;
  color: #0369a1;
  background: #e0f2fe;
}

:deep(.traspasos-table .p-row-toggler:hover) {
  background: #bae6fd;
}
</style>
